import React from 'react';
import { Button } from '@cloudclevr/components';

/**
 * TokenRefreshError
 * 
 * Error boundary UI shown when token refresh fails in impersonation mode.
 * Provides a button to reload the iframe and re-authenticate.
 */
export const TokenRefreshError: React.FC = () => {
  const handleReload = () => {
    // Clear auth state
    sessionStorage.clear();
    
    // Reload the iframe
    window.location.reload();
  };

  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: '1rem' }}>
        <svg 
          width="64" 
          height="64" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          style={{ color: '#F59E0B' }}
        >
          <path 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      
      <h2 style={{ 
        fontSize: '1.5rem', 
        fontWeight: 600, 
        marginBottom: '0.5rem',
        color: '#1F2937'
      }}>
        Authentication Session Expired
      </h2>
      
      <p style={{ 
        fontSize: '1rem', 
        marginBottom: '1.5rem',
        color: '#6B7280',
        maxWidth: '400px'
      }}>
        Your session could not be refreshed. Please reload to continue accessing this customer&apos;s data.
      </p>
      
      <Button 
        onClick={handleReload}
        variant="primary"
        size="medium"
      >
        Reload
      </Button>
    </div>
  );
};
